import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { marked } from 'marked';

// In progress
@Component({
  selector: 'app-markdown',
  templateUrl: './markdown.component.html',
  styleUrls: ['./markdown.component.scss'],
})
export class MarkdownComponent implements OnInit, OnChanges {
  @Input() public input: string = '';
  @Input() public citations: string[] = [];

  htmlContent: SafeHtml = '';

  constructor(private sanitizer: DomSanitizer) {}

  async ngOnInit() {
    this.parseInput();
  }

  ngOnChanges() {
    this.parseInput();
  }

  private async parseInput() {
    if (!this.input) {
      this.htmlContent = '';
      return;
    }
    let rawHtml: string | Promise<string> = marked.parse(this.input);
    if (rawHtml instanceof Promise) {
      rawHtml = await rawHtml;
    }

    // Work with the raw HTML string before sanitizing
    let htmlString = rawHtml as string;

    if (this.citations && this.citations.length > 0) {
      // Replace citation placeholders with links
      htmlString = htmlString.replace(/\[(\d+)\]/g, (match, citationIndex) => {
        const index = parseInt(citationIndex, 10) - 1;
        if (index >= 0 && index < this.citations.length) {
          return `<a class="markdown-citation" target="_blank" rel="noopener noreferrer" href="${
            this.citations[index]
          }">${match.replace(/\D/g, '')}</a>`;
        }
        return match;
      });

      // Add target="_blank" and rel="noopener noreferrer" to all other links
      htmlString = htmlString.replace(
        /<a href/g,
        '<a target="_blank" rel="noopener noreferrer" href'
      );
    }

    // Sanitize the final HTML string
    this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(htmlString);
  }
}
